<app-dialog
	modalTitle="Pendência"
	titleButton="Salvar"
	[secButton]="false"
	[hideFooter]="false"
	[noMargins]="true"
	[disabled]="form.invalid || disableWithRhRule() || isLoading"
	(dialogClose)="closeModal()"
	(dialogSave)="saveChanges()"
>
	<ng-container *ngIf="isLoading">
		<div class="d-f jc-c mt-md">
			<mat-spinner diameter="20"></mat-spinner>
		</div>
	</ng-container>
	<ng-container *ngIf="!isLoading">
		<div [formGroup]="form">
			<mat-form-field
				class="mt-xxxs mr-xxxs ml-xxxs"
				title="Status"
				appearance="outline"
			>
				<mat-label>Status</mat-label>
				<mat-select
					formControlName="pendency"
					(selectionChange)="onStatusChange($event)"
				>
					<mat-option
						*ngFor="let status of pendenciesStatus"
						[disabled]="status.disabled"
						[value]="status.id"
					>
						{{ status.label }}
					</mat-option>
				</mat-select>
				<mat-error *ngIf="form.get('pendency')?.hasError('required')">
					Campo obrigatório
				</mat-error>
			</mat-form-field>

			<ng-container formArrayName="items">
				<ng-container *ngFor="let pForm of items.controls; let fg = index">
					<div class="d-f ai-c ml-xxxs mr-xxxs" [formGroupName]="fg">
						<mat-checkbox
							color="primary"
							class="mb-xxs"
							formControlName="isComplete"
						></mat-checkbox>
						<mat-form-field
							class="ml-xxs w-100"
							title="Pendência"
							appearance="outline"
						>
							<mat-label>Pendência</mat-label>
							<input
								type="text"
								matInput
								placeholder="Pendência"
								formControlName="name"
							/>
						</mat-form-field>
						<div class="ml-xxxs mb-xxs" *ngIf="data.sanusMode">
							<button
								mat-icon-button
								color="warn"
								(click)="removePendencyItem(pForm.value, fg)"
							>
								<mat-icon>delete</mat-icon>
							</button>
						</div>
					</div>
				</ng-container>
			</ng-container>
		</div>
		<div class="add-btn ml-xxxs">
			<button
				mat-flat-button
				color="primary"
				(click)="addPendencyItem()"
				[disabled]="shouldDisableAddPendency()"
			>
				Adicionar pendência
			</button>
		</div>
		<div class="mb-xxxl mt-xxs ml-xxxs mr-xxxs mb-xxs">
			<ng-container *ngFor="let msg of messages">
				<p class="fs-xxs fw-bold mb-xxxs" *ngIf="msg.pendency.length">
					{{ msg.to }}:
				</p>
				<ng-container *ngFor="let id of msg.pendency">
					<p class="fs-xxxs mb-nano">- {{ alertMessage(id) }}</p>
				</ng-container>
			</ng-container>
		</div>
	</ng-container>
</app-dialog>
